

module.exports = __webpack_require__.stylable.create(
    "Tooltip2919015201",
    {"classes":{"root":"Tooltip2919015201__root"},"vars":{},"stVars":{},"keyframes":{}},
    ".Tooltip2919015201__root .Popover1103664861__popoverContent{overflow-wrap:break-word;word-wrap:break-word;word-break:break-word}",
    2,
    "Tooltip2919015201",
    __webpack_require__.stylable.$
);
